import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Directive({
  selector: '[score]',
})
export class ScoreDirective {
  @Input() icon: MatIcon | undefined;
  @Input() set score(scoreString: string | null | undefined) {
    let score = Number(scoreString);
    if (score && !isNaN(score)) {
      let scoreClass = Math.floor(score / 9);
      let svgIcon = `score-points-${scoreClass}`;
      if (this.icon) {
        this.icon.svgIcon = svgIcon;
      }
    }
  }
  constructor(
    private elementRef: ElementRef<MatIcon>,
    private renderer: Renderer2
  ) {}
}
